<template>
    <svg width="11" height="6" class="mt-1 ml-1.5 group-aria-expanded:rotate-180 transition-transform duration-200"
        viewBox="0 0 11 6" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M0.5 0.5L5.5 5.5L10.5 0.5" stroke="currentColor" stroke-width="0.833333" stroke-linecap="round"
            stroke-linejoin="round" />
    </svg>
</template>